import Button from "components/Button";
import { useEffect, useState } from "react";

import SvgUpdateInfo from "assets/svgs/update-information.svg";
import SvgUpdateSource from "assets/svgs/update-source.svg";
import SvgUpdateTimeline from "assets/svgs/update-location.svg";
import SvgEmptyFollows from "assets/svgs/empty-follows.svg";

const renderIcon = (type) => {
  switch (type) {
    case "Timeline":
      return <SvgUpdateTimeline className="flex-shrink-0" width="32" />;
    case "Source":
      return <SvgUpdateSource className="flex-shrink-0" width="32" />;
    default:
      return <SvgUpdateInfo className="flex-shrink-0" width="32" />;
  }
};

export default function CaseUpdates({ outsetaUserCaseList }) {
  const [caseUpdates, setCaseUpdates] = useState([]);
  const [filteredCases, setFilteredCases] = useState([]);
  const [areUpdatesLoading, setAreUpdatesLoading] = useState(false);

  const followedCases =
    outsetaUserCaseList && outsetaUserCaseList !== ""
      ? outsetaUserCaseList.split(",")
      : [];
  const followedCasesSlugs = followedCases.map((v) => ({ slug: v }));
  const filterBySlug = (arr1 = [], arr2 = []) => {
    let res = [];
    res = arr1.filter((el) => {
      return arr2.find((element) => {
        return element?.slug === (el?.lookupSlug || [])[0];
      });
    });
    return res;
  };

  const getCaseUpdates = async (numRecords = 500) => {
    setAreUpdatesLoading(true);
    let isActive = true;
    const caseUpdatesResponse = await fetch(
      `/api/utilities/get-case-updates${
        numRecords !== 500 ? `?numRecords=${numRecords}` : ""
      }`
    );
    const caseUpdatesResult = await caseUpdatesResponse.json();

    if (isActive) {
      setCaseUpdates(caseUpdatesResult);
      setAreUpdatesLoading(false);
    }

    //clean up function in case component unmounts before fetch completes
    return () => {
      isActive = false;
    };
  };

  useEffect(() => {
    getCaseUpdates();
  }, []);

  useEffect(() => {
    if (caseUpdates.length > 0 && followedCases.length > 0) {
      const filteredUnorderedCases = filterBySlug(
        caseUpdates,
        followedCasesSlugs
      );
      setFilteredCases(
        filteredUnorderedCases.sort(function (a, b) {
          return new Date(b.dateOfChange) - new Date(a.dateOfChange);
        })
      );
    }
  }, [outsetaUserCaseList, caseUpdates]);

  return (
    <>
      <h2 className="font-semibold text-lg">Your Case Updates</h2>
      <p className="mb-6 text-sm">
        Clicking “Follow” on a case will add it to your “Cases You Following”
        section. And when a case is updated, it will appear in “Your Case
        Updates” section so you never miss new information on the cases you care
        about.
      </p>
      {areUpdatesLoading ? (
        <>
          <p className="mb-4 p-4">
            <strong className="font-semibold">Loading Case Updates...</strong>
          </p>
        </>
      ) : filteredCases.length > 0 ? (
        <div className="bg-white pb-6 px-6 shadow-md">
          <ul>
            {filteredCases.map((filteredCase) => {
              const {
                dateOfChange,
                lookupFirstName,
                lookupLastName,
                summary,
                updateType,
                url,
              } = filteredCase;
              return (
                <li className="flex pt-6" key={summary && summary}>
                  {updateType && renderIcon(updateType)}
                  <div className="ml-2">
                    <span className="font-semibold text-sm">
                      {lookupFirstName && lookupFirstName}{" "}
                      {lookupLastName && lookupLastName}&apos;s case has been updated{" "}
                    </span>
                    {dateOfChange && (
                      <span className="font-semibold inline-block text-gray-400 text-xs">
                        {dateOfChange}
                      </span>
                    )}
                    <span className="bg-gray-50 block p-2 text-xs">
                      {summary && summary}
                      {url && (
                        <a
                          className="font-semibold inline-block ml-2 text-red hover:text-red-700"
                          href={url}
                        >
                          View Update
                        </a>
                      )}
                    </span>
                  </div>
                </li>
              );
            })}
          </ul>
        </div>
      ) : (
        <article className="bg-white p-14 text-center">
          <SvgEmptyFollows className="mb-6 mx-auto max-w-full" width="520" />
          <p className="mb-6 text-lg">
            <strong className="block mb-4 text-2xl">
              You have no recent case updates.
            </strong>
            Follow more cases to see updates everytime a case is updated.
          </p>
          <Button
            className="text-sm"
            href={"/cases"}
            emphasis="primary"
            height="32"
          >
            View Cases
          </Button>
        </article>
      )}
    </>
  );
}
